import { Validation } from '../../../../interfaces/common';
import { GenerateStatement } from '../../../../interfaces/managerStatement.interface';
import { APP_ERROR_MESSAGES, VALIDATION_FIELD_MAPPING } from '../../../../utils/appConstant';

export const validateGenerateStatementForm = (formData: GenerateStatement, isManagerEditable: boolean, fieldToValidate?: string): Validation => {
  const validations: Validation = { validate: true, fields: [] };

  if (isManagerEditable && (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.manager)) {
    if (!formData.manager) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.manager,
        message: APP_ERROR_MESSAGES.reconciliation.managerStatement.blankManager,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.month) {
    if (!formData.month) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.month,
        message: APP_ERROR_MESSAGES.reconciliation.managerStatement.blankMonth,
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.year) {
    if (!formData.year) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.year,
        message: APP_ERROR_MESSAGES.reconciliation.managerStatement.blankYear,
      });
    }
  }

  return validations;
};
